module.exports = __webpack_public_path__ + "img/whatsapp.6542db84.svg";